<template>
	<v-app>
		<v-navigation-drawer v-model="drawer" fixed app>
			<v-list dense two-line subheader>
				<v-list-tile
					v-for="item in routeItems"
					:key="item.route"
					@click="openPortal(item)"
				>
					<v-list-tile-action>
						<v-icon medium>{{ item.icon }}</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title class="subheading">
							<span v-if="item.highlight" :style="getColor(item)">{{
								item.title
							}}</span>
							<span v-else>{{ item.title }}</span>
						</v-list-tile-title>
						<v-list-tile-sub-title></v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
		</v-navigation-drawer>
		<v-toolbar app>
			<v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
			<v-toolbar-title class="font-weight-regular text-uppercase">
				<span>{{ title }}</span>
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-menu
				id="admin-date-menu"
				v-model="menu"
				ref="menu"
				:close-on-content-click="false"
				:nudge-right="40"
				:return-value.sync="dates"
				lazy
				transition="scale-transition"
				offset-y
				full-width
				min-width="290px"
			>
				<!-- hint="Set validity for the privilege" -->
				<v-combobox
					label="Select Dates"
					slot="activator"
					v-model="dates"
					multiple
					chips
					small-chips
					persistent-hint
					readonly
					color="black darken-3"
					style="margin-top:14px"
				></v-combobox>
				<!-- :min="new Date().toISOString().substr(0, 10)" -->
				<v-date-picker
					color="black darken-2"
					v-model="dates"
					multiple
					no-title
					scrollable
				>
					<v-spacer></v-spacer>
					<v-btn flat color="pink" @click="menu = false">Cancel</v-btn>
					<v-btn flat color="orange darken-1" @click="saveDates">OK</v-btn>
				</v-date-picker>
			</v-menu>
		</v-toolbar>
		<v-dialog v-model="loaderDialog" persistent max-width="75">
			<v-progress-circular
				indeterminate
				color="amber"
				:size="70"
				:width="7"
			></v-progress-circular>
		</v-dialog>
		<v-snackbar
			v-model="snackbar"
			left
			:color="snackbarColor"
			:timeout="snackbarTime"
			top
			multi-line
		>
			{{ snackbarText }}
			<!-- <v-btn color="pink" flat @click.stop="closeSnackbar">Close</v-btn> -->
		</v-snackbar>
		<v-content>
			<router-view />
		</v-content>
	</v-app>
</template>

<script>
import moment from 'moment-timezone';
import { mapGetters, mapMutations } from 'vuex';
export default {
	name: 'Admin',
	data() {
		return {
			drawer: null,
			routeItems: [
				{
					icon: 'bubble_chart',
					title: 'Dashboard',
					route: '/',
					highlight: false,
				},
				{
					icon: 'graphic_eq',
					title: 'End Points',
					route: '/end-points',
					highlight: false,
				},
			],
			dates: [],
			menu: false,
			moment: false,
			snackbar: false,
			timeout: 3000,
			title: 'SSE/Dashboard',
		};
	},
	created() {
		this.moment = moment;
	},
	methods: {
		...mapMutations([
			'setSelectedDates',
			'openLoaderDialog',
			'openSnackbar',
			'closeSnackbar',
		]),
		openPortal(item) {
			this.title = this.title.split('/')[0] + '/' + item.title;
			if (item.hasOwnProperty('prop')) {
				this.$router.push({
					name: item.route,
					params: {
						propItem: item.prop,
					},
				});
			} else {
				this.$router.push({
					path: item.route,
				});
			}
		},
		saveDates() {
			// this.dates.splice(2, this.dates.length);
			if (this.dates.length > 0) {
				let d = this.dates.sort(function(a, b) {
					return a < b ? -1 : a > b ? 1 : 0;
				});

				this.dates = [d[0], d[d.length - 1]];

				this.setSelectedDates(Object.assign([], this.dates));
				this.$refs.menu.save(this.dates);
				// console.log(this.getSelectedDates);
			}
		},
		getColor(item) {
			return {
				color: item.highlight,
			};
		},
	},
	computed: {
		...mapGetters([
			'getSelectedDates',
			'loaderDialog',
			'snackbarState',
			'snackbarText',
			'snackbarColor',
			'snackbarTime',
			'startDay',
		]),
	},
	mounted() {
		if (
			Number(
				moment()
					.tz('Asia/Kolkata')
					.format('DD')
			) >= this.startDay
		) {
			this.dates[0] = moment()
				.startOf('month')
				.add(this.startDay - 1, 'day')
				.tz('Asia/Kolkata')
				.format('YYYY-MM-DD');
			this.dates[1] = moment()
				.startOf('month')
				.add(1, 'month')
				.add(this.startDay - 1, 'day')
				.tz('Asia/Kolkata')
				.format('YYYY-MM-DD');
		} else {
			this.dates[0] = moment()
				.startOf('month')
				.subtract(1, 'month')
				.add(this.startDay - 1, 'day')
				.tz('Asia/Kolkata')
				.format('YYYY-MM-DD');
			this.dates[1] = moment()
				.startOf('month')
				.add(this.startDay - 1, 'day')
				.tz('Asia/Kolkata')
				.format('YYYY-MM-DD');
		}
		this.saveDates();

		this.$store.subscribe(mutation => {
			if (mutation.type === 'openSnackbar') {
				this.snackbar = true;
			} else if (mutation.type === 'closeSnackbar') {
				this.snackbar = false;
			}
		});
		// this.openSnackbar({ text: "This is a test please work", time:10000 });
		this.openPortal({
			icon: 'graphic_eq',
			title: 'End Points',
			route: '/end-points',
			highlight: false,
		});
	},
};
</script>

<style lang="scss">
#admin-date-menu {
	.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
		border-color: black;
	}

	.mdi-menu-down:before {
		color: black !important;
	}

	.theme--light.v-label {
		color: black !important;
	}

	.v-chip .v-chip__content {
		color: black;
	}
}
</style>
